import FileSaver from 'file-saver';

import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getAllStudentCredentials = ({
  version = 'v1',
  params = {},
} = {}) =>
  client
    .request({
      url: `${version}/clr/credentials/get-all-student-credentials/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getCredentialCounts = ({ version = 'v1', params = {} } = {}) =>
  client
    .request({
      url: `${version}/clr/credentials/counts-by-type/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createCredential = ({ data, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/clr/credentials/`,
      method: RequestMethod.POST,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

/* CHAPI requires context with the '@' so we need to transform the response object */
export const exportCredential = ({ exportUrl } = {}) =>
  client
    .request({
      url: exportUrl,
      method: RequestMethod.GET,
    })
    .then(({ data: responseData, headers }) => {
      const blob = new Blob(
        [
          JSON.stringify(
            {
              ...responseData,
              '@context': responseData.context,
              context: undefined,
            },
            undefined,
            2,
          ),
        ],
        {
          type: 'application/json',
        },
      );

      const fileName = headers['content-disposition']
        .split('filename=')[1]
        .replace(/["']/g, '');

      FileSaver.saveAs(blob, fileName);
    })
    .catch(handleError);

export const shareCredential = ({ shareUrl } = {}) =>
  client
    .request({
      url: `${shareUrl}/share/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getCredentialDetails = ({
  type,
  credentialId,
  version = 'v1',
  params = {},
} = {}) =>
  client
    .request({
      url: `${version}/clr/credentials/student-credential-details/${type}/${credentialId}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const setCredentialVisibility = ({
  type,
  credentialId,
  version = 'v1',
  data = {},
} = {}) =>
  client
    .request({
      url: `${version}/clr/credentials/student-credential-details/${type}/${credentialId}/update-visibility/`,
      method: RequestMethod.POST,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const exportStudentClr = ({ version = 'v1', data = {} } = {}) =>
  client
    .request({
      url: `${version}/clr/clrs/export-student-clr/`,
      method: RequestMethod.POST,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const validateUploadedCredential = ({
  data = {},
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/clr/credentials/validate-credential-data/`,
      method: RequestMethod.POST,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getPublicUserInfo = ({ userId, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/clr/public-user-info/${userId ? `${userId}/` : ''}`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);
